import React from 'react';

import { useEditableWidget } from '@lumapps/designer-legacy-widget-settings/hooks/useEditableWidget';
import type { EditableWidgetProps } from '@lumapps/designer-legacy-widget-settings/types';
import { BackendRecomputedWidget } from '@lumapps/widget-base/components/BackendRecomputedWidget';

import type { LegacyWidgetIntroProps } from '../../type';
import { EditableWidgetIntro, EditableWidgetIntroProps } from '../EditableWidgetIntro';

export interface LegacyWidgetIntroWrapperProps extends EditableWidgetProps<LegacyWidgetIntroProps> {}

export interface EditableWidgetIntroProperties {
    content?: string;
}

export const LegacyWidgetIntroWrapper: React.FC<LegacyWidgetIntroWrapperProps> = ({
    legacyWidget: initLegacyWidget,
    switchToReadMode,
    saveTextInWidgetProperties,
    isEditingContent,
    isWidgetEmpty,
    ...props
}) => {
    const getTranslateObject = React.useCallback((properties?: LegacyWidgetIntroProps) => properties?.content, []);

    const { legacyWidget, content, editableWidgetProps } = useEditableWidget<LegacyWidgetIntroProps>(
        initLegacyWidget,
        switchToReadMode,
        saveTextInWidgetProperties,
        getTranslateObject,
    );

    return (
        <BackendRecomputedWidget<LegacyWidgetIntroProps, EditableWidgetIntroProperties, EditableWidgetIntroProps>
            legacyWidget={legacyWidget}
            editableWidgetRenderer={EditableWidgetIntro}
            editableWidgetProps={editableWidgetProps}
            isWidgetEmpty={isWidgetEmpty}
            blockProperties={{ text: content }}
            editingContent={isEditingContent}
            canUseLangFallback={false}
            {...props}
        />
    );
};
